import { FC } from "react"
import { Anchor } from "../../app/components/anchor"
import { BlokImage } from "../../storyblok"
import LogoIcon from "../svgs/Logo"

const ProductNavbar: FC<{
  blok: { buttonLabel?: string; buttonLink?: string; image: BlokImage }
}> = (props) => {
  const { buttonLabel, buttonLink = "/" } = props.blok
  return (
    <nav id="product-navbar">
      <div className="max-w-[1400px] w-full px-4 md:py-2 mx-auto">
        <div className="flex justify-between items-center h-16">
          <Anchor
            href="/"
            className="flex items-center py-2 px-2 hover:no-underline no-underline"
          >
            <LogoIcon />
          </Anchor>

          <div className="hidden md:flex items-center space-x-4 ">
            <Anchor
              href={buttonLink}
              className="text-md uppercase border border-gray14 hover:no-underline  text-gray14 rounded-full p-2 md:p-4"
            >
              {buttonLabel}
            </Anchor>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default ProductNavbar
